<template>
  <div class="home">
    <!-- <Header></Header> -->
    <div class="content">
      <!-- <router-view name="home"></router-view> -->
      <Sidebar></Sidebar>
      <Main></Main>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import Header from '@/components/Header.vue'
import Sidebar from '@/components/Sidebar.vue'
import Main from '@/components/Main.vue'

export default {
  name: 'HomeView',
  components: {
    // Header
    Sidebar,
    Main
  },
  mounted () {
    // this.toView('/navigation/main')
    // this.toView('/login')
  },
  methods: {
    toView (path) {
      this.$router.push(path)
      console.log(path)
    }
  }
}
</script>

<style scoped>
.home {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.content {
  flex: 1;
  display: flex;
  overflow: hidden;
}

</style>
